import { render, staticRenderFns } from "./videoDraw.vue?vue&type=template&id=d389cabe&scoped=true&"
import script from "./videoDraw.vue?vue&type=script&lang=js&"
export * from "./videoDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d389cabe",
  null
  
)

export default component.exports